//
import { RForm, RTable } from '@/components/reusable_components/next'

//
import SlSaleCreditNoteFields from '@/views/Sale/SlSaleCreditNote/fields'
import SlSaleCreditNoteFilters from '@/views/Sale/SlSaleCreditNote/filters'
import SlSaleCreditNoteHeaders from '@/views/Sale/SlSaleCreditNote/headers'
import SlSaleCreditNoteService from '@/services/api/Sale/SlSaleCreditNote'

//
export default {
  components: {
    RForm,
    RTable,
  },
  computed: {

    /**
     * 
     */
    formProps() {
      return {
        editable: false,
        fields: SlSaleCreditNoteFields,
      }
    },

    /**
     * 
     */
    tableProps() {
      return {
        filters: SlSaleCreditNoteFilters.slice(0, 2),
        headers: SlSaleCreditNoteHeaders,
        service: SlSaleCreditNoteService.toList(),
      }
    }
  },
  data() {
    return {
      dialogs: {
        detail: false,
      },
      selected: {},
    }
  },
  methods: {

    /**
     * 
     */
    onCreate(event) {
      this.$router.push({ name: 'sale-credit-note-create' })
    },

    /**
     * 
     */
    onDetail(event) {
      this.selected = event.item.reset()
      this.dialogs.detail = true 
    },

    /**
     * 
     */
    onPrint(event) {
      event.item.toPdf()
    },
  },
  mounted() {
    this.setTitle('Notas de crédito')
    this.setItems([
      {
        action: this.onCreate,
        icon: 'add_circle',
        text: 'crear nota de crédito',
        tooltip: 'Crear nueva nota de crédito',
      },
    ])
  },
}